import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Encuesta } from '../model/encuesta.model';

@Injectable({
  providedIn: 'root'
})
export class EncuestasService {

  private apiUrl = `${environment.apiUrl}/api/encuestas`;

  constructor(private http: HttpClient) {}

  /** Obtiene todas las encuestas (sin preguntas) */
  getEncuestas(): Observable<Encuesta[]> {
    return this.http.get<Encuesta[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Obtiene una encuesta con todas sus preguntas y opciones */
  getEncuestaById(id: number): Observable<Encuesta> {
    return this.http.get<Encuesta>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Crea una encuesta con sus preguntas y opciones en un solo request */
  createEncuesta(encuesta: Encuesta): Observable<Encuesta> {
    return this.http.post<Encuesta>(this.apiUrl, encuesta, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Actualiza una encuesta completa (título, descripción, preguntas y opciones) */
  updateEncuesta(id: number, encuesta: Encuesta): Observable<Encuesta> {
    return this.http.put<Encuesta>(`${this.apiUrl}/${id}`, encuesta, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Inactiva una encuesta */
  inactivarEncuesta(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, { estado: 0 }, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Obtiene todas las respuestas enviadas para una encuesta */
  getRespuestasEncuesta(encuestaId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${encuestaId}/respuestas`, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  /** Obtiene la encuesta sin autenticación (ruta pública) */
  getEncuestaPublica(nit: string, id: number): Observable<Encuesta> {
    return this.http.get<Encuesta>(`${environment.apiUrl}/api/public/encuesta/${nit}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('[EncuestasService] handleError — error HTTP completo:', error);
    return throwError(() => error);
  }
}